/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Pipe, PipeTransform} from '@angular/core';
import {UserBaseModel} from '../../../api/ms-security/contracts/user-base.model';
import {UserSummaryModel} from '../../../api/ms-security/contracts/user-summary.model';

@Pipe({
    name: 'userDisplay',
    standalone: false
})
export class UserDisplayPipe implements PipeTransform {

    transform(value: UserBaseModel | UserSummaryModel, removeUsername?: boolean): any {
        if (removeUsername) {
            return value ? `${value.firstName} ${value.lastName}` : null;
        } else {
            return value ? `${value.firstName} ${value.lastName} (${value.username})` : null;
        }

    }

}
